import * as _ from 'lodash';
import type { FunctionComponent } from 'react';

import { plural } from '../../../../../shared/helpers/plural';

import Relationships from './Relationships';
import type { MinimalDependencyLock, Path } from './useDependencyPaths';

import styles from './ModalViewRelationships.module.less';

const MAX_PATHS = 30;

type RelationshipListProps = {
  paths: Path[][];
  projectTitle: string | null;
  dependencyLocks: Record<string, MinimalDependencyLock>;
};

const RelationshipList: FunctionComponent<RelationshipListProps> = ({
  paths,
  projectTitle,
  dependencyLocks,
}) => {
  const pathsByLocator = _.groupBy(paths, path => path[0]?.locator);
  return (
    <>
      <p className={styles.title}>
        {projectTitle} is included in {paths.length >= MAX_PATHS ? 'at least ' : null}{paths.length}{' '}
        {plural(paths.length, 'way')}:
      </p>
      {Object.entries(pathsByLocator).map(([baseRev, groupedPaths]) => (
        <>
          <Relationships
            baseRevision={baseRev}
            groupedPaths={groupedPaths}
            projectTitle={projectTitle}
            dependencyLocks={dependencyLocks}
          />
          <hr />
        </>
      ))}
    </>
  );
};

export default RelationshipList;
